import SectionHead from "./SectionHead";
import { guideSteps } from "@/mocks/homeContent";

export default function Guide() {
  return (
    <section id="guide" className="w-full scroll-mt-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-16 md:px-6 md:py-24">
        <SectionHead
          eyebrow="HOW TO DIG · 找料指引"
          title="翻库三步，之后越用越顺手"
          desc="黑料舍把找料流程做得很省心：先分区、再收窄、后回翻。下面的方法帮你在私藏存货里快速定位，不迷路。"
        />

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {guideSteps.map((s) => (
            <div
              key={s.no}
              className="relative overflow-hidden rounded-xl border border-[#ded2bb] bg-white p-6"
            >
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -right-2 -top-4 font-editorial text-[72px] font-semibold italic text-[#f0e6cd]"
              >
                {s.no}
              </span>
              <div className="relative">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#201b15] text-xl text-[#e9c579]">
                  <i className={s.icon} aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-[17px] font-bold text-[#241f18]">{s.title}</h3>
                <p className="mt-2 text-[13px] leading-relaxed text-[#6d6149]">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* tool-ish lookup bar */}
        <div className="mt-8 flex w-full flex-col items-center justify-between gap-6 overflow-hidden rounded-xl bg-[#1a1510] px-6 py-8 md:flex-row md:px-10">
          <div className="flex max-w-xl flex-col items-center gap-2 text-center md:items-start md:text-left">
            <span className="flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] text-[#c8a45f]">
              <i className="ri-tools-line text-[14px]" aria-hidden="true" />
              LOOKUP DESK · 找料台
            </span>
            <h3 className="font-song text-[20px] font-semibold text-[#f6eeda] md:text-[24px]">
              一时想不起来看哪个分区？
            </h3>
            <p className="text-[13px] leading-relaxed text-[#b7a98d]">
              输入主题或关键词，帮你从已入库的档目里筛出最相关的那一批。
            </p>
          </div>
          <div className="flex w-full max-w-md flex-col gap-3">
            <label
              htmlFor="vault-search"
              className="flex items-center gap-3 rounded-md border border-[#4a4134] bg-[#241e16] px-4 py-3 text-[#c8a45f]"
            >
              <i className="ri-search-line text-lg" aria-hidden="true" />
              <input
                id="vault-search"
                name="vault_keyword"
                type="text"
                placeholder="输入主题或关键词…"
                className="w-full bg-transparent text-sm text-[#efe5d2] outline-none placeholder:text-[#8a7a5c]"
              />
            </label>
            <button
              type="button"
              className="whitespace-nowrap rounded-md bg-[#e3b04f] px-5 py-3 text-sm font-bold text-[#241f18] transition-colors hover:bg-[#f0c56b]"
            >
              开始检索
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}